import React from 'react'
import type { ToolbarProps } from 'react-big-calendar'
import { CalendarToolbar } from '../../CalendarToolbar'
import { useCalendar } from '../CalendarContext'
import SalesCalendarEstimatorSelect from './SalesCalendarEstimatorSelect'

export default function SalesCalendarToolbar(props: ToolbarProps) {
  const { events, hideWeekends, loading, date, fetchingIntegrationEvents, setDate, tab, view, setView } = useCalendar()
  const activeView = tab === 'map' ? view : props.view
  return (
    <CalendarToolbar
      {...props}
      events={events}
      date={date}
      setDate={setDate}
      tab={tab}
      view={activeView}
      setView={setView}
      loading={loading}
      fetchingIntegrationEvents={fetchingIntegrationEvents}
      hideWeekends={hideWeekends}
      EstimatorSelectComponent={<SalesCalendarEstimatorSelect />}
    />
  )
}
